<template>
  <v-layout column>
    <div class="text-center">
      <section>
        <v-container
          class="d-flex align-center"
          :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-top: 150px;` : `padding-top: 25px;`">
          <v-row 
            justify="center" 
            align="center">
            <v-col>
              <v-card
                flat
                color="transparent"
                class="pa-4">
                <v-row 
                  justify="center" 
                  align="center">
                  <v-col>
                    <div>
                      <v-img 
                        contain
                        :width="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 150 : 90"
                        :height="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 150 : 90"
                        alt="jdih" 
                        :src="require('@/assets/image/500.png')"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <div>
                      <div :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'my-10' : 'my-6'">
                        <div 
                          class="font-weight-bold black--text mb-3"
                          :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'title' : 'body-2'">
                          Data yang di cari tidak ditemukan
                        </div>

                        <div 
                          class="black--text font-weight-light line-text-second"
                          :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-1' : 'caption'">
                          Tautan yang Anda kunjungi mungkin rusak atau tidak ada lagi. cobalah beberapa saat lagi
                        </div>
                      </div>
                      
                      <v-btn
                        to="/beranda"
                        large
                        rounded
                        elevation="0"
                        class="body-1 font-weight-bold white--text text-capitalize btn_auth"
                        :style="`background: linear-gradient(180deg, ${set_color_rgb} 0%, ${set_color} 100%);`">
                        <div
                          class="btn_auth_in"
                          :style="`background: linear-gradient(180deg, ${set_color_rgb} 0%, ${set_color_rgb_up} 100%);`">
                          <v-icon>mdi-arrow-left-thick</v-icon>
                          kembali ke beranda
                        </div>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </div>
  </v-layout>
</template>

<script> 
  import { createSEOMeta } from '@/utils/seo'
  export default {
    name: 'error-500',
    data () {
      return {
        // SEO
        content: {
          url: '',
          title: '500',
          description: 'Internal server error',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    props: {
      error: {
        type: Object,
        default: () => {},
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    computed: {
      token() {
        return this.$store.state.member.auth.token
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      }
    }
  }
</script>